import { workspaceVisible } from './workspaceVisibility';

export const READ_PURPOSES = {
  result:new Set(['prefetch','open','refresh','download']),
  history:new Set(['history_head','history_search','history_page','history_export','history_delta','landing_latest']),
  import_status:new Set(['import_list','import_watch','import_resume']),
  quota:new Set(['quota_refresh']),status_poll:new Set(['job_progress']),
};
export const readPurpose = (operation, value) => READ_PURPOSES[operation]?.has(value) ? value : undefined;
export const readVisibility = () => workspaceVisible() ? 'visible' : 'hidden';
export function readEventSource(operation,purpose,startedVisibility) {
  const current = readVisibility();
  const state = startedVisibility===current ? current : current==='visible' ? 'became_visible' : 'became_hidden';
  return `${operation}_${purpose || 'unknown'}_${state}`;
}
